import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const updateData = createAsyncThunk(
  "Data/updateData",
  async (updateApiFunction, thunkAPI) => {
    const changes = thunkAPI.getState().changeDetected.changes;
    const {serverId} = thunkAPI.getState().serverId;
    console.log("changes", changes)
    const response = await updateApiFunction(serverId, changes);
    console.log("response", response);
    thunkAPI.dispatch(clearChanges());
    thunkAPI.dispatch(setChangesDetected(false));
  }
);

export const cancelChanges = (dispatch) => {
    dispatch(setChangesDetected(false));
}


const initialState = {
  changes: {},
  changesDetected: false,
};

const changeDetectedSlice = createSlice({
  name: 'changeDetected',
  initialState,
  reducers: {
    addChange: (state, action) => {
      state.changes = {
        ...state.changes, 
        [action.payload.key]: action.payload.value
      };
    },
    clearChanges: (state) => {
      state.changes = {};
    },
    setChangesDetected: (state, action) => {
      state.changesDetected = action.payload;
    },
  },
});

export const { addChange, clearChanges, setChangesDetected } = changeDetectedSlice.actions;
export const changeDetected = changeDetectedSlice.reducer;

